import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { Typography, Tooltip } from "@mui/material";
import { IConfirmAndSaveButton } from "./ConfirmAndSaveButtonInterfaces";
import DoneOutlinedIcon from "@mui/icons-material/DoneOutlined";
import { useStyles } from "./ConfirmAndSaveButton.styles";
import { HMICachedDataContext } from "contexts/HMICachedDataContext/HMICachedDataContext";

export const ConfirmAndSaveButton = ({ handleClick, failureCode, operator, disabled }: IConfirmAndSaveButton) => {
    const { t } = useTranslation();
    const classes = useStyles();
    const { store } = useContext(HMICachedDataContext);

    return (
        <>
            <Tooltip
                placement="top"
                PopperProps={{
                    className: classes.tooltip,
                }}
                open={!operator}
                title={
                    <Typography className={classes.tooltipTexts}>
                        {t("HMI.failure_details.confirm_and_save_tooltip_text")}
                    </Typography>
                }
            >
                <button
                    onClick={handleClick}
                    type="button"
                    className={
                        !operator ||
                        (store.isEventReportEditing && typeof failureCode === "string" && failureCode === "") ||
                        disabled
                            ? classes.disabledButton
                            : classes.button
                    }
                    disabled={
                        !operator ||
                        (store.isEventReportEditing && typeof failureCode === "string" && failureCode === "") ||
                        disabled
                    }
                >
                    <Typography variant="h5">
                        <span className={classes.confirmMessage}>
                            <DoneOutlinedIcon className={classes.icon} />{" "}
                            {t("HMI.failure_details.confirm_and_save").toUpperCase()}
                        </span>
                    </Typography>
                </button>
            </Tooltip>
        </>
    );
};
